import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import type { LexicalEditor } from 'lexical';

interface EditorRefPluginProps {
  editorRef: React.RefObject<LexicalEditor | null>;
}

export function EditorRefPlugin({ editorRef }: EditorRefPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // Using type assertion to work around RefObject immutability
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    (editorRef as React.MutableRefObject<LexicalEditor | null>).current = editor;
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      (editorRef as React.MutableRefObject<LexicalEditor | null>).current = null;
    };
  }, [editor, editorRef]);

  return null;
}
